import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const StarknetLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2460_2127)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12C0 18.6276 5.37243 24 11.9998 24C18.6272 24 24 18.6276 24 12C24 5.37252 18.6272 0 11.9998 0C5.37243 0 0 5.37252 0 12Z"
          fill="#0C0C4F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.707 9.26569L7.00321 8.35628C7.06343 8.17133 7.21033 8.02739 7.39715 7.97064L8.31679 7.68961C8.44408 7.65098 8.44511 7.47252 8.31885 7.43183L7.40335 7.13747C7.21756 7.07764 7.07271 6.93166 7.01526 6.74602L6.73279 5.83216C6.69392 5.706 6.51433 5.70464 6.47338 5.83046L6.17716 6.73986C6.11695 6.92448 5.97004 7.06842 5.78322 7.1255L4.86358 7.4062C4.73629 7.44517 4.73491 7.62329 4.86152 7.66396L5.77703 7.95833C5.96281 8.01817 6.10766 8.16449 6.16511 8.35012L6.44758 9.26365C6.48645 9.39014 6.66604 9.39151 6.707 9.26569Z"
          fill="#FAFAFA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2427 8.73639C20.8636 8.31511 20.272 8.07791 19.6967 7.98063C19.1169 7.88721 18.5089 7.89589 17.9365 7.99693C16.7783 8.19162 15.7261 8.66819 14.8083 9.2561C14.3317 9.54463 13.9253 9.87849 13.5043 10.2185C13.3014 10.3905 13.1164 10.5736 12.9238 10.7541L12.3974 11.2745C11.8255 11.8686 11.2618 12.4097 10.7163 12.8582C10.1687 13.3046 9.65667 13.6437 9.15209 13.8804C8.64784 14.1184 8.10828 14.2584 7.405 14.2808C6.70791 14.3052 5.88316 14.1802 5.00096 13.9739C4.11402 13.7684 3.18264 13.4756 2.14185 13.2236C2.50501 14.2248 3.05187 15.1094 3.75399 15.9182C4.46435 16.7129 5.35136 17.4373 6.49086 17.9137C7.61389 18.4006 9.02518 18.5752 10.3448 18.3115C11.6679 18.0586 12.829 17.4501 13.7675 16.7466C14.7084 16.0358 15.4697 15.226 16.1115 14.3842C16.2886 14.1517 16.3823 14.0215 16.5105 13.8397L16.8649 13.3181C17.1111 12.9955 17.3353 12.6282 17.5789 12.3085C18.0568 11.639 18.528 10.9704 19.0755 10.3543C19.351 10.0418 19.6416 9.74295 19.9846 9.45572C20.1556 9.31551 20.3405 9.17832 20.5452 9.05471C20.753 8.92142 20.9725 8.81707 21.2427 8.73639Z"
          fill="url(#paint0_linear_2460_2127)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2427 8.73635C20.8355 7.71509 20.0783 6.8554 19.0619 6.22102C18.0518 5.59362 16.6489 5.27343 15.2585 5.54638C14.5718 5.67836 13.9064 5.93249 13.3224 6.27092C12.7411 6.60799 12.2203 7.01376 11.7693 7.44906C11.5442 7.66745 11.3399 7.89525 11.1369 8.12434L10.6107 8.79094L9.79807 9.86398C8.76208 11.2446 7.64646 12.8625 5.81565 13.3419C4.01834 13.8126 3.23881 13.3958 2.14185 13.2236C2.34243 13.7382 2.59087 14.2379 2.92769 14.6775C3.25824 15.126 3.64868 15.5473 4.13409 15.9084C4.37939 16.0818 4.63838 16.253 4.92601 16.3982C5.21236 16.5384 5.52114 16.6619 5.85073 16.7549C6.50632 16.9334 7.24441 16.9959 7.95905 16.8999C8.67402 16.8051 9.35742 16.5799 9.95477 16.2809C10.5565 15.9848 11.0807 15.624 11.5488 15.2433C12.4793 14.4754 13.203 13.627 13.8144 12.7695C14.1219 12.3407 14.401 11.9038 14.6591 11.4668L14.963 10.9466C15.0559 10.7945 15.1498 10.6415 15.2452 10.499C15.6302 9.9265 16.0068 9.46742 16.4642 9.12286C16.9152 8.76938 17.5433 8.50822 18.3825 8.44754C19.2182 8.38614 20.1831 8.49955 21.2427 8.73635Z"
          fill="#FAFAFA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7212 17.2219C16.7212 17.9719 17.3335 18.5804 18.0883 18.5804C18.8432 18.5804 19.4546 17.9719 19.4546 17.2219C19.4546 16.4717 18.8432 15.8634 18.0883 15.8634C17.3335 15.8634 16.7212 16.4717 16.7212 17.2219Z"
          fill="url(#paint1_linear_2460_2127)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2460_2127"
          x1="21.1407"
          y1="8.37803"
          x2="4.37934"
          y2="17.7502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC796B" />
          <stop offset="1" stopColor="#E175B1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2460_2127"
          x1="19.4537"
          y1="16.2688"
          x2="16.7198"
          y2="16.5598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC796B" />
          <stop offset="1" stopColor="#E175B1" />
        </linearGradient>
        <clipPath id="clip0_2460_2127">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const StarknetLogo = withLogo(StarknetLogoComponent);
